const translation = {
  tags: {
    productivity: 'بهره وری',
    news: 'اخبار',
    medical: 'پزشکی',
    image: 'تصویر',
    search: 'جستجو',
    other: 'دیگر',
    utilities: 'تاسیسات',
    design: 'طراحی',
    entertainment: 'سرگرمی',
    social: 'اجتماعی',
    education: 'آموزش',
    business: 'تجاری',
    finance: 'مالی',
    weather: 'هوا',
    travel: 'سفر',
    videos: 'فیلم',
    agent: 'عامل',
  },
  searchTags: 'جستجو برچسب ها',
  allTags: 'همه برچسب ها',
}

export default translation
